<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import autoRefresh from '@/utils/auto-update.js'
  export default {
    name: 'App',
    mounted(){
      autoRefresh()
    }
  }
</script>

<style lang="scss">
  @import '@/sass/index.scss';
  @import '@/sass/common.scss';
  #app{
    height: 100%;
    overflow-x: auto;
  }
</style>
